module.exports = __webpack_public_path__ + "static/media/s11.bf2ebf35.png";